import moment from 'moment'
moment.locale('pt-br');
 const listingFormated = state => {
  return state.listing.map(item => {
    

    if (item.action == "auth") {
      item.log = item.log == null ? '' : JSON.parse(item.log);
      item.hostpotName = "";
      if (item.log.hotspot_description) {
      	item.hostpotName = item.log.hotspot_description;
      }
      item.text = "Usuário se conectou a " + item.hostpotName;
    }else if (item.action == "revoke") {
      item.log = item.log == null ? '' : JSON.parse(item.log);
      if ( item.log.field !== undefined ) {
      	item.text = "Revogou acesso ao " + getName(item.log.field) + " para " + item.log.customer_name;
      }
    }else if (item.action == "change") {
      item.log = item.log == null ? '' : JSON.parse(item.log);
      if (item.log.field !== undefined ) {
      	item.text = "Alterou o " + getName(item.log.field) + " para " + item.log.customer_name;
      }
    }else if (item.action == "consent") {
      item.log = item.log == null ? '' : JSON.parse(item.log);
      item.hostpotName = "";
      if (item.log.hotspot_description) {
        item.hostpotName = item.log.hotspot_description;
      }
      item.text = "Consentiu acesso ao " + getName(item.log.field) + item.hostpotName;
    }else{
      if (item.action) {
        item.log = item.log == null ? '' : JSON.parse(item.log);
        var description = item.action;
        description += ( item.log.customer_name !== undefined ? ' ' + item.log.customer_name : '' );
        description += ( item.log.hotspot_description !== undefined ? ' ' + item.log.hotspot_description : '' );
        description += ( item.log.field !== undefined ? ' ' + item.log.field : '' ) ;
        item.text = description;
      }
    }



    function getName(arr){
      var dic = {
        'gender': 'Gênero',
        'name': 'Nome',
        'email': 'Email',
        'locale': 'Localidade',
        'birthday': 'Aniversário',
        'docnumber': 'Documento',
        'phone': 'Telefone',
        'photo': 'Foto'
      }
      var array = [];
      for (var i = 0; i < arr.length; i++) {
        array.push(dic[arr[i]]);
      }
      return array.join(', ');
    }

    item.longTxt = item.text;
    if (item.text.length > 60) {
      item.text = item.text.slice(0, 59) + '..';
    }

    if (item.created_at !== undefined) {
      item.created_at = moment(item.created_at).format('L HH:mm')
    }

    return item;
  });
}

export default {
  listingFormated
}